"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _styledComponents.default.ul.withConfig({
  displayName: "LinkList",
  componentId: "design-system__sc-1g5whj7-0"
})(["background-color:rgb(255,255,255);box-sizing:border-box;padding:1rem 0;list-style-type:none;& > li{border-bottom:1px solid ", ";height:2.5rem;display:flex;align-items:center;font-size:", ";line-height:", ";}& > li:last-child{border-bottom:none;}& div.link-icon{margin-right:", ";display:flex;align-items:center;}"], _BaseTheme.default.colors.bluegray, _BaseTheme.default.type.size.small, _BaseTheme.default.type.lineHeight.extra, _BaseTheme.default.distance.small);

exports.default = _default;